import { apiGet, apiJson } from '../api/client';
import type { KokoroGender, KokoroPin } from './types';

interface PinsListResponse {
  pins: Record<string, KokoroPin>;
}

export async function listPins(): Promise<Record<string, KokoroPin>> {
  const res = await apiGet<PinsListResponse>('/api/voice/kokoro-pins');
  return res.pins ?? {};
}

export async function upsertPin(
  agentName: string,
  body: {
    voice_id: string;
    gender: KokoroGender | null;
    world_seed: string;
    /** Stage 8: present when the pin captures a full VoiceSpec (blend mode). */
    spec_json?: string | null;
  },
): Promise<void> {
  await apiJson<{ ok: true }>(
    'PUT',
    `/api/voice/kokoro-pins/${encodeURIComponent(agentName)}`,
    body,
  );
}

export async function deletePin(agentName: string): Promise<void> {
  await apiJson<{ ok: true }>(
    'DELETE',
    `/api/voice/kokoro-pins/${encodeURIComponent(agentName)}`,
  );
}
